// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609141241/js/" + chunkId + "." + {"44":"85ebac32","225":"ed268348","481":"431ba298","486":"183731fe","770":"24dcfb25"}[chunkId] + ".0.38334118504045545.chunk.js";
};